exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slidecontainer {\r\n    width: 100%;\n}\n.slider {\r\n    -webkit-appearance: none;\r\n    width: 100%;\r\n    height: 25px;\r\n    background: #d3d3d3;\r\n    outline: none;\r\n    opacity: 0.7;\r\n    transition: opacity .2s;\n}\n.slider:hover {\r\n    opacity: 1;\n}\n.slider::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    width: 25px;\r\n    height: 25px;\r\n    background: #04AA6D;\r\n    cursor: pointer;\n}\n.slider::-moz-range-thumb {\r\n    width: 25px;\r\n    height: 25px;\r\n    background: #04AA6D;\r\n    cursor: pointer;\n}\r\n", ""]);

// exports
